// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeltaPriceComponent } from './delta-price.component';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';

@NgModule({
    declarations: [
        DeltaPriceComponent,
    ],
    imports: [
        CommonModule,
        PricePipesModule,
        PricePipeModule,
    ],
    exports: [
        DeltaPriceComponent,
    ],
    providers: [],
})
export class DeltaPriceModule {}